var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"componente-card"}},[_c('div',{staticClass:"w3-row w3-margin-bottom"},[_c('div',{staticClass:"w3-col s12"},[_c('div',{staticClass:"w3-white w3-block"},[_vm._t("default"),_vm._v(" "),_c('hr')],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-583947a0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ComponenteCard.vue
// module id = null
// module chunks = 